import React from 'react';
import './Services.css';

const Services: React.FC = () => {
  return (
    <div className="services">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <h1>Our Services</h1>
          <p>Comprehensive healthcare revenue cycle management solutions</p>
        </div>
      </section>

      {/* Main Services */}
      <section className="main-services">
        <div className="container">
          <div className="section-header">
            <h2>Core Services</h2>
            <p>POST-ACCUTE CARE/LONG-TERM CARE</p>
          </div>
          
          <div className="services-grid">
            <div className="service-card" id="billing">
              <div className="service-icon">💰</div>
              <h3>Medical Billing Services</h3>
              <p>Complete medical billing and coding solutions to maximize your revenue potential.</p>
              <ul>
                <li>Medical Billing & Coding</li>
                <li>Charge Entry</li>
                <li>Claims Submission</li>
                <li>Denials Management</li>
                <li>Insurance Follow-ups</li>
                <li>Payments Posting</li>
              </ul>
            </div>
            
            <div className="service-card" id="authorization">
              <div className="service-icon">📋</div>
              <h3>Prior Authorization</h3>
              <p>Streamlined authorization processes to ensure timely patient care and reimbursement.</p>
              <ul>
                <li>Eligibility & Benefits Verifications</li>
                <li>Patient/Insurance/Attorney</li>
                <li>Payer Communication</li>
                <li>Patient Insurance Verification</li>
                <li>Submit Prior Authorization</li>
              </ul>
            </div>
            
            <div className="service-card" id="oasis">
              <div className="service-icon">🔍</div>
              <h3>Quality Assurance Services</h3>
              <p>Comprehensive quality assurance to maintain compliance and improve patient outcomes.</p>
              <ul>
                <li>OASISI-E1+485 Review</li>
                <li>Medical Records Review</li>
                <li>Medical Auditing</li>
                <li>HIPAA Compliance</li>
                <li>Quality Management Systems</li>
                <li>Electronic Health Records</li>
              </ul>
            </div>
            
            <div className="service-card" id="rcm">
              <div className="service-icon">📊</div>
              <h3>Revenue Cycle Management</h3>
              <p>End-to-end revenue cycle optimization to maximize financial performance.</p>
              <ul>
                <li>Maximizing Revenue Potential</li>
                <li>Seamless Financial Operations</li>
                <li>Proactive Revenue Optimization</li>
                <li>Tailored Financial Solutions</li>
                <li>Streamlined Revenue Processes</li>
                <li>Comprehensive Revenue</li>
              </ul>
            </div>
            
            <div className="service-card" id="virtual">
              <div className="service-icon">💻</div>
              <h3>Medical Virtual Assistance</h3>
              <p>Virtual support services to enhance patient care and administrative efficiency.</p>
              <ul>
                <li>Patient Care Coordination</li>
                <li>Medical Scribe</li>
                <li>VA Clinical Support Live Calls</li>
                <li>Chat Admin Assistant</li>
                <li>Client Support Associate</li>
              </ul>
            </div>
            
            <div className="service-card" id="intake">
              <div className="service-icon">📅</div>
              <h3>Patient Intake and Scheduling</h3>
              <p>Efficient patient registration and scheduling systems for optimal workflow.</p>
              <ul>
                <li>Patent Registration & Scheduling</li>
                <li>Patient Calling Recruitment</li>
                <li>Patient Support ADRs</li>
                <li>Appointment Scheduling</li>
                <li>Waitlist Management</li>
              </ul>
            </div>

            <div className="service-card" id="cred_&_contract">
              <div className="service-icon">✅</div>
              <h3>Credentialing and Contracting</h3>
              <p>Streamlined credentialing and contracting services to ensure providers are properly enrolled and contracted with payers.</p>
              <ul>
                <li>Provider Credentialing & Group/Practice Enrollment</li>
                <li>CAQH, PECOS & NPPES Setup and Maintenance</li>
                <li>Medicare/Medicaid Enrollment & Revalidation</li>
                <li>Commercial Insurance Enrollment and Updates</li>
                <li>New Provider Onboarding & Roster Updates</li>
                <li>Practice Demographic Updates & Payer Follow-ups</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Specialties */}
      <section className="specialties">
        <div className="container">
          <div className="section-header">
            <h2>Specialties We Serve</h2>
            <p>Outpatient/Community/Long-Term Care</p>
          </div>
          
          <div className="specialties-grid">
            <div className="specialty-card" id="home-health">
              <h3>Home Health</h3>
              <p>Comprehensive billing and management services for home health agencies, ensuring compliance with Medicare and Medicaid requirements.</p>
              <ul>
                <li>OASIS Assessment Management</li>
                <li>Episode Management</li>
                <li>Quality Reporting</li>
                <li>Compliance Monitoring</li>
              </ul>
            </div>
            
            <div className="specialty-card" id="home-care">
              <h3>Home Care</h3>
              <p>Specialized services for home care providers, focusing on private pay and insurance billing optimization.</p>
              <ul>
                <li>Private Pay Management</li>
                <li>Insurance Verification</li>
                <li>Care Plan Management</li>
                <li>Family Communication</li>
              </ul>
            </div>
            
            <div className="specialty-card" id="hospice">
              <h3>Hospice Care</h3>
              <p>Compassionate billing services for hospice providers, ensuring proper reimbursement for end-of-life care.</p>
              <ul>
                <li>Hospice Billing</li>
                <li>Level of Care Management</li>
                <li>Medicare/Medicaid Compliance</li>
                <li>Family Support Services</li>
              </ul>
            </div>
            
            <div className="specialty-card" id="urgent-care">
              <h3>Urgent Care</h3>
              <p>Fast-paced billing solutions for urgent care centers, optimizing revenue from walk-in patients.</p>
              <ul>
                <li>Rapid Claims Processing</li>
                <li>Insurance Verification</li>
                <li>Co-pay Collection</li>
                <li>Denial Management</li>
              </ul>
            </div>
            
            <div className="specialty-card" id="emergency">
              <h3>Emergency Room</h3>
              <p>Emergency department billing expertise, handling complex cases and high-volume claims efficiently.</p>
              <ul>
                <li>Emergency Billing</li>
                <li>Trauma Case Management</li>
                <li>Insurance Authorization</li>
                <li>High-Volume Processing</li>
              </ul>
            </div>
            
            <div className="specialty-card" id="assisted-living">
              <h3>Assisted Living Facilities</h3>
              <p>Comprehensive billing services for assisted living communities, managing multiple payer sources.</p>
              <ul>
                <li>Multi-Payer Management</li>
                <li>Resident Billing</li>
                <li>Family Communication</li>
                <li>Medicaid Waiver Programs</li>
              </ul>
            </div>
            
            <div className="specialty-card" id="skilled-nursing">
              <h3>Skilled Nursing Facilities</h3>
              <p>Specialized billing for SNFs, ensuring proper Medicare Part A and B reimbursement.</p>
              <ul>
                <li>Medicare Part A Billing</li>
                <li>Medicare Part B Services</li>
                <li>MDS Management</li>
                <li>Quality Measures</li>
              </ul>
            </div>
            
            <div className="specialty-card">
              <h3>Mental & Behavioral Health</h3>
              <p>Specialized billing services for mental health and behavioral health providers.</p>
              <ul>
                <li>Mental Health Billing</li>
                <li>Behavioral Health Services</li>
                <li>Substance Abuse Treatment</li>
                <li>Insurance Authorization</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Service Benefits */}
      <section className="service-benefits">
        <div className="container">
          <h2>Why Choose Our Services?</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">⚡</div>
              <h3>Fast Processing</h3>
              <p>Quick turnaround times for claims submission and processing to improve cash flow.</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🎯</div>
              <h3>High Accuracy</h3>
              <p>95% accuracy rate with our certified coders and quality assurance specialists.</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🔒</div>
              <h3>HIPAA Compliant</h3>
              <p>100% HIPAA compliant processes to protect patient privacy and data security.</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">📈</div>
              <h3>Revenue Growth</h3>
              <p>Average 20% increase in revenue collection for our clients.</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🛡️</div>
              <h3>Denial Reduction</h3>
              <p>Proactive auditing reduces claim denials and improves first-pass success rates.</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">📊</div>
              <h3>Transparent Reporting</h3>
              <p>Real-time reporting and analytics to track your revenue cycle performance.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Technology */}
      <section className="technology">
        <div className="container">
          <div className="tech-content">
            <div className="tech-text">
              <h2>Powered by Advanced Technology</h2>
              <p>
                Our services are enhanced by cutting-edge technology including AI-powered coding, 
                automated claim processing, and real-time analytics. We integrate seamlessly with 
                your existing EHR/EMR systems to provide a unified workflow experience.
              </p>
              <ul className="tech-features">
                <li>AI-Powered Coding Assistance</li>
                <li>Automated Claim Processing</li>
                <li>Real-Time Analytics Dashboard</li>
                <li>EHR/EMR Integration</li>
                <li>Mobile Access</li>
                <li>Cloud-Based Security</li>
              </ul>
            </div>
            <div className="tech-visual">
              <div className="tech-card">
                <h3>Seamless Integration</h3>
                <p>Connect with your existing systems</p>
              </div>
              <div className="tech-card">
                <h3>AI-Powered</h3>
                <p>Advanced automation and accuracy</p>
              </div>
              <div className="tech-card">
                <h3>Real-Time</h3>
                <p>Live reporting and analytics</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Optimize Your Revenue Cycle?</h2>
            <p>Let our experts help you maximize your revenue potential with our comprehensive services.</p>
            <div className="cta-actions">
              <a href="tel:6570000000" className="btn btn-primary">Get Started Today</a>
              <a href="mailto:[email]" className="btn btn-secondary">Request Quote</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
